import Button from "components/Button/Button"

function ButtonPrimary(props) {
  return <Button {...props} pattern="primary" />
}

export default ButtonPrimary
